"use client"

import { styled } from "@mui/material";
import { PageLayout } from "../pageLayout";

export const StyledDosing = styled(PageLayout)(({ theme }) => ({
  
  [theme.breakpoints.down('md')]: {
    '.wrapped .accordion-wrapper': {
      paddingLeft: '0 !important',
    },
  }
}))